import React, { useEffect, useState } from 'react';
import Loadable from '@/components/common/loadable';
import Modal from '@/components/common/modal';
import Button from '@/components/common/button';
import { ICON } from '../../common/icon/iconFlag';
import { useHistory } from 'react-router-dom';

const CategoryForm = Loadable({
  loader: () => import('../form'),
});

const CreateCategory = ({ initParentId, isOpen = false, onClose }) => {
  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(isOpen);

  useEffect(() => {
    setIsModalVisible(isOpen);
  }, [isOpen]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const close = () => {
    onClose?.();
    setIsModalVisible(false);
  };

  const submit = (p) => {
    close();
    if (p?.data?.id) {
      history.push(`/category/${p?.data?.id}`);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} flagIcon={ICON.ICONS_PLUS} fixedIcon>
        Add Category
      </Button>
      <Modal title="Add category" open={isModalVisible} onClose={close} width="90%">
        <CategoryForm
          mode="edit"
          onCloseModal={close}
          onSubmit={submit}
          formName="create-category-form"
          initParentId={initParentId}
        />
      </Modal>
    </>
  );
};

export default CreateCategory;
